import { useContext, useMemo, useState } from "react";
import { removeHoverOfSection } from "utils";
import { WdprNavIconButton } from "components/vista";
import SectionTxp from "../section/SectionTxp";
import Cart from "../section/cart/Cart";
import { useIconButtonVariant } from "hooks/txp/useIconButtonVariant";
import {
	defaultIconVariant,
	profileSectionIds,
	searchOpenLinkId,
} from "config-txp";
import { Context } from "Context";
import AnalyticsWrapper from "components/shared/AnalyticsWrapper";

const RightNavigation = ({
	isTxp,
	store,
	searchBarToggle,
	chrome,
	syndicatedNavigationToggleClass,
	brand,
	showSearchBar,
	handleSearchBarToggle,
	isMobileView,
	extraOptions,
	handleCloseMenu,
	isMenuActive,
	setIsMenuActive,
	sectionRefs,
	collapsedSection,
	setCollapsedSection,
	isHeaderHovered,
	isScrolling,
	hoveredSection,
	setHoveredSection,
	setSearchBarToggle,
	headerRef,
	backdropRef,
	showCart,
}) => {
	const {
		config: { chrome: showChromeItems },
	} = useContext(Context);

	const variant = useIconButtonVariant({
		toggle: isHeaderHovered,
		isScrolling,
		brand,
	});
	const inverse = variant === defaultIconVariant;
	const [mouseIsHovering, setMouseIsHovering] = useState(false);
	const profileSection = useMemo(
		() =>
			profileSectionIds
				.map((key) => extraOptions?.[key])
				.find((section) => !!section),
		[extraOptions]
	);

	const handleSearchButtonKeyDown = (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			handleSearchBarToggle();
		}
	};
	return (
		!isMobileView &&
		isTxp && (
			<div className={`${syndicatedNavigationToggleClass}--wrapper`}>
				{showChromeItems && profileSection && (
					<SectionTxp
						card={true}
						compactDelays={true}
						{...profileSection}
						setCollapsedSection={setCollapsedSection}
						collapse={
							!isMobileView ||
							(isMobileView && collapsedSection === profileSection.id)
						}
						ref={(el) => (sectionRefs.current[profileSection.id] = el)}
						isMenuActive={true}
						setIsMenuActive={setIsMenuActive}
						store={store}
						brand={brand}
						isLastSection={false}
						handleFullClose={() => {
							handleCloseMenu();
							removeHoverOfSection();
						}}
						showLogginStatus
						flyoutPosition="left"
						txp
						isHeaderHovered={isHeaderHovered}
						isScrolling={isScrolling}
						hoveredSection={hoveredSection}
						setHoveredSection={setHoveredSection}
						setSearchBarToggle={setSearchBarToggle}
						searchBarToggle={searchBarToggle}
						headerRef={headerRef}
						backdropRef={backdropRef}
					/>
				)}
				{showCart && extraOptions?.cart && (
					<Cart
						{...extraOptions.cart}
						isMenuActive={isMenuActive}
						setIsMenuActive={setIsMenuActive}
						txp={true}
						isHeaderHovered={isHeaderHovered}
						isScrolling={isScrolling}
						setSearchBarToggle={setSearchBarToggle}
						searchBarToggle={searchBarToggle}
						isLastSection={false}
						setHoveredSection={setHoveredSection}
					/>
				)}
				{showChromeItems && showSearchBar && (
					<AnalyticsWrapper
						analyticsLinkId={
							!searchBarToggle ? `${brand}${searchOpenLinkId}` : ""
						}
						pageTransitionLink={false}
					>
						<div
							role="button"
							tabIndex={0}
							aria-label={chrome?.accessibilityTextShowSearch}
							aria-expanded={searchBarToggle}
							onKeyDown={handleSearchButtonKeyDown}
							onClick={handleSearchBarToggle}
						>
							<WdprNavIconButton
								ariaExpanded={searchBarToggle}
								a11yLabel={chrome?.accessibilityTextShowSearch}
								disabled={!showSearchBar}
								iconName="search"
								inverse={inverse}
								allowKeyboardChevron={false}
								active={searchBarToggle && mouseIsHovering}
								onWdprNavIconButtonHover={(e) =>
									setMouseIsHovering(e.detail.value)
								}
								tabIndex={-1}
							/>
						</div>
					</AnalyticsWrapper>
				)}
			</div>
		)
	);
};

export default RightNavigation;
